import React, { useRef, useEffect, useState } from 'react';
import { Input, DatePicker, Form, notification } from '@ss/mtd-react';
import { Select } from '@block/plug';
import { observer } from 'mobx-react-lite';
import { useSetState } from 'ahooks';
import { useRootStore } from '@src/model';
import cloneDeep from 'lodash/cloneDeep';
import { getEnumByCategory, getSchoolEnum, getMajorEnum, getCollegeEnum } from '@service/resumeDetail';
import ModuleView from '../../ModuleView';

import './index.scss';

const FormItem = Form.Item;
interface IEduExpInfo {
  collegeCode: string;
  collegeName: string;
  degree: string;
  degreeName: string;
  endDate: number;
  startDate: number;
  labLevel: string | null;
  labLevelName: string | null;
  laboratory: string | null;
  major: number;
  majorCode: number;
  researchDirection: number;
  mentor: string;
  school: string;
  schoolCode: string;
  scoreRanking: string;
  scoreRankingName: string;
  unionId: string;
  renderId?: number;
}

type TType = 'campus' | 'social';
interface IProps {
  type: TType;
  data: IEduExpInfo[];
  resetHaveIntentionApplyErrorList?: () => void;
}

interface FilterStatus {
  [key: string]: any;
}

function EduExperience(props: IProps) {
  const formRefs = useRef<any[]>([]);
  const [labLevelNameSelect, setLabLevelNameSelect] = useState(true);
  const { type, data, resetHaveIntentionApplyErrorList } = props;
  const { campusResumeDetail, socialResumeDetail, socialResumeFormRefStore, campusResumeFormRefStore } = useRootStore();
  // 判断所有notMessage是'无数据' or '请输入'
  const [filterStatus, setFilterStatus] = useSetState<FilterStatus>({});

  let store;
  let storeRef;
  if (type === 'campus') {
    store = campusResumeDetail;
    storeRef = campusResumeFormRefStore;
  }
  if (type === 'social') {
    store = socialResumeDetail;
    storeRef = socialResumeFormRefStore;
  }

  useEffect(() => {
    storeRef.changeRef('resumeEduExpListRef', formRefs.current);
    const cloneData = cloneDeep(data);
    cloneData?.forEach((item, index) => {
      if (item.unifiedEntrance === true) item.unifiedEntrance = '是';
      if (item.unifiedEntrance === false) item.unifiedEntrance = '否';
      if (item.fullTimeStatus === true) item.fullTimeStatus = '是';
      if (item.fullTimeStatus === false) item.fullTimeStatus = '否';
      if (item.endDate === 253370736000000) item.endDate = '';
      if (item.labLevel === '6') {
        item.laboratory = '';
        setLabLevelNameSelect(false);
      } else {
        setLabLevelNameSelect(true);
      }
      formRefs.current[index]?.setFieldsValue({
        unifiedEntrance: item.unifiedEntrance,
        endDate: item.endDate,
        fullTimeStatus: item.fullTimeStatus,
      });
    });
  }, [data, data?.length]);

  const handleValueChange = (index: number, formItemKey: string, formItemValue: any) => {
    switch (formItemKey) {
      case 'school': {
        store.setResumeEduExpList(index, 'school', formItemValue?.name ? formItemValue.name : '');
        store.setResumeEduExpList(index, 'schoolCode', formItemValue?.id ? formItemValue.id : '');
        if (type === 'campus') {
          store.setResumeEduExpList(index, 'collegeName', '');
          store.setResumeEduExpList(index, 'collegeCode', '');
          store.setResumeEduExpList(index, 'major', '');
          store.setResumeEduExpList(index, 'majorCode', '');
          formRefs.current[index]?.setFieldsValue({ collegeName: '', major: '' });
        }
        break;
      }
      case 'major': {
        store.setResumeEduExpList(index, 'major', formItemValue?.name ? formItemValue.name : '');
        store.setResumeEduExpList(index, 'majorCode', formItemValue?.id ? formItemValue.id : '');
        break;
      }
      case 'degreeName': {
        store.setResumeEduExpList(index, 'degreeName', formItemValue?.name ? formItemValue.name : '');
        store.setResumeEduExpList(index, 'degree', formItemValue?.id ? formItemValue.id : '');
        break;
      }
      case 'scoreRankingName': {
        store.setResumeEduExpList(index, 'scoreRankingName', formItemValue?.name ? formItemValue.name : '');
        store.setResumeEduExpList(index, 'scoreRanking', formItemValue?.id ? formItemValue.id : '');
        break;
      }
      case 'unifiedEntrance': {
        store.setResumeEduExpList(index, 'unifiedEntrance', formItemValue?.code);
        break;
      }
      case 'fullTimeStatus': {
        store.setResumeEduExpList(
          index,
          'fullTimeStatus',
          // eslint-disable-next-line no-nested-ternary
          formItemValue?.id === '1' ? true : formItemValue === null ? undefined : false,
        );
        break;
      }
      case 'labLevelName': {
        store.setResumeEduExpList(index, 'labLevelName', formItemValue?.name ? formItemValue.name : '');
        store.setResumeEduExpList(index, 'labLevel', formItemValue?.id ? formItemValue.id : '');
        if (formItemValue?.id === '6') {
          setLabLevelNameSelect(false);
          store.setResumeEduExpList(index, 'laboratory', '');
          formRefs.current[index]?.setFieldsValue({ laboratory: '' });
          formRefs.current[index]?.clearValidateStatus(['laboratory']);
        } else {
          setLabLevelNameSelect(true);
        }
        break;
      }
      case 'collegeName': {
        store.setResumeEduExpList(index, 'collegeName', formItemValue?.name ? formItemValue.name : '');
        store.setResumeEduExpList(index, 'collegeCode', formItemValue?.id ? formItemValue.id : '');
        if (type === 'campus') {
          store.setResumeEduExpList(index, 'major', '');
          store.setResumeEduExpList(index, 'majorCode', '');
          formRefs.current[index]?.setFieldsValue({ major: '' });
        }
        break;
      }
      case 'startDate':
      case 'endDate': {
        store.setResumeEduExpList(index, formItemKey, formItemValue);
        resetHaveIntentionApplyErrorList && resetHaveIntentionApplyErrorList();
        break;
      }
      default:
        store.setResumeEduExpList(index, formItemKey, formItemValue);
    }
  };

  const handleFetchData = async (category, filter = '', index = '') => {
    if (!filter) {
      setFilterStatus({ [`${category}-${index}`]: null });
    }
    let res;
    if (category === 'school') {
      res = await getSchoolEnum({ filter });
    } else if (category === 'major') {
      const param =
        type === 'campus'
          ? {
              schoolCode: store.resumeEduExpList[index]?.schoolCode || '',
              collegeCode: store.resumeEduExpList[index]?.collegeCode || '',
              filter,
              type,
            }
          : { filter, type };
      res = await getMajorEnum(param);
    } else if (category === 'college') {
      res = await getCollegeEnum({
        schoolCode: store.resumeEduExpList[index]?.schoolCode || '',
        filter,
      });
    } else if (category === 'unifiedEntrance') {
      // 解决火狐兼容性问题
      const sleep = (time: number) =>
        new Promise((resolve) => {
          setTimeout(resolve, time);
        });
      await sleep(100);
      res = [
        { name: '是', code: true },
        { name: '否', code: false },
      ];
    } else if (category === 'fullTimeStatus') {
      const sleep = (time: number) =>
        new Promise((resolve) => {
          setTimeout(resolve, time);
        });
      await sleep(100);
      res = [
        { id: '1', name: '是' },
        { id: '0', name: '否' },
      ];
    } else {
      res = await getEnumByCategory({ category, filter });
    }
    setFilterStatus({ [`${category}-${index}`]: filter });
    return res;
  };

  const deleteResumeEduExpList = (index) => {
    if (data?.length <= 1) {
      notification.error({
        title: '错误',
        message: '请至少填写一段教育经历',
      });
      return false;
    }
    store.deleteResumeList('resumeEduExpList', index);
    return true;
  };

  return (
    <div className="edu_experience_edit model_edit">
      <div className="model_title">
        教育经历<span className="education_tips">请完整填写大学及以上的教育经历哦</span>
      </div>
      {data?.map((item, index) => (
        <div className="model_list" key={item.renderId}>
          <Form
            defaultFieldsValue={item}
            className="modal_form"
            ref={(el) => {
              formRefs.current[index] = el;
            }}
            onFieldValueChange={(formItemKey, formItemValue) => handleValueChange(index, formItemKey, formItemValue)}
          >
            <FormItem formItemKey="school" span="11" labelWidth={0} required message="请填写学校名称">
              <div className="label">
                学校名称
                <span className="icon">*</span>
              </div>
              <Select
                toFormItem
                size="large"
                placeholder="请选择"
                labelField="name"
                keyField="id"
                notFoundMessage={filterStatus?.[`school-${index}`] ? '无数据' : '请输入'}
                // @ts-ignore
                onFetchData={(filter) => handleFetchData('school', filter, index)}
              />
            </FormItem>
            {type === 'campus' && (
              <FormItem formItemKey="collegeName" span="11" labelWidth={0} required message="请填写学院">
                <div className="label">
                  学院名称<span className="icon">*</span>
                </div>
                <Select
                  toFormItem
                  disabled={!store.resumeEduExpList[index].school}
                  size="large"
                  placeholder="请选择"
                  labelField="name"
                  keyField="id"
                  notFoundMessage={filterStatus?.[`college-${index}`] ? '无数据' : '请输入'}
                  // @ts-ignore
                  onFetchData={(filter) => handleFetchData('college', filter, index)}
                />
              </FormItem>
            )}
            <FormItem formItemKey="major" span="11" labelWidth={0} required message="请填写专业">
              <div className="label">
                专业名称<span className="icon">*</span>
              </div>
              <Select
                toFormItem
                disabled={
                  type === 'social'
                    ? false
                    : !store.resumeEduExpList[index].school || !store.resumeEduExpList[index].collegeName
                }
                size="large"
                placeholder="请选择"
                labelField="name"
                keyField="id"
                notFoundMessage={filterStatus?.[`major-${index}`] ? '无数据' : '请输入'}
                // @ts-ignore
                onFetchData={(filter) => handleFetchData('major', filter, index)}
              />
            </FormItem>
            <FormItem formItemKey="degreeName" span="11" labelWidth={0} required message="请填写学历">
              <div className="label">
                学历<span className="icon">*</span>
              </div>
              <Select
                toFormItem
                size="large"
                placeholder="请选择"
                labelField="name"
                keyField="id"
                notFoundMessage={filterStatus?.[`diploma-${index}`] ? '无数据' : '请输入'}
                // @ts-ignore
                onFetchData={(filter) => handleFetchData('diploma', filter, index)}
              />
            </FormItem>

            <FormItem
              className="form_item_start_date_campus"
              formItemKey="startDate"
              span="4"
              labelWidth={0}
              required
              message="请填写入学时间"
            >
              <div className="label">
                在校时间<span className="icon">*</span>
              </div>
              <DatePicker
                toFormItem
                size="large"
                format="YYYY/MM"
                valueFormat="timestamp"
                placeholder="入学时间"
                disabledDate={(cur) => {
                  if (item?.endDate) return cur > item.endDate;
                  return false;
                }}
              />
              <div className="inner-line" />
            </FormItem>

            <FormItem
              className="form_item_end_date_campus"
              formItemKey="endDate"
              span="3"
              labelWidth={0}
              required
              message="请填写毕业时间"
            >
              <div className="label"> </div>
              <DatePicker
                toFormItem
                size="large"
                format="YYYY/MM"
                valueFormat="timestamp"
                placeholder="毕业时间"
                disabledDate={(cur) => {
                  if (item?.startDate) return cur < item.startDate;
                  return false;
                }}
              />
            </FormItem>

            {type === 'campus' && (
              <FormItem formItemKey="scoreRankingName" span="11" labelWidth={0} required message="请填写成绩排名">
                <div className="label">
                  成绩排名<span className="icon">*</span>
                </div>
                <Select
                  toFormItem
                  size="large"
                  placeholder="请选择"
                  labelField="name"
                  keyField="id"
                  notFoundMessage={filterStatus?.[`rank-${index}`] ? '无数据' : '请输入'}
                  // @ts-ignore
                  onFetchData={(filter) => handleFetchData('rank', filter, index)}
                />
              </FormItem>
            )}
            {/* {type === 'campus' && (
              <FormItem formItemKey="unifiedEntrance" span="11" labelWidth={0} required message="请选择是否统招">
                <div className="label">
                  是否统招<span className="icon">*</span>
                </div>
                <Select
                  toFormItem
                  size="large"
                  placeholder="请选择"
                  labelField="name"
                  keyField="code"
                  notFoundMessage={filterStatus?.[`unifiedEntrance-${index}`] ? '无数据' : '请输入'}
                  // @ts-ignore
                  onFetchData={(filter) => handleFetchData('unifiedEntrance', filter, index)}
                />
              </FormItem>
            )} */}
            {type === 'campus' && (
              <FormItem formItemKey="fullTimeStatus" span="11" labelWidth={0} required message="请选择是否全日制">
                <div className="label">
                  是否全日制<span className="icon">*</span>
                </div>
                <Select
                  toFormItem
                  size="large"
                  placeholder="请选择"
                  labelField="name"
                  keyField="id"
                  onFetchData={(filter) => handleFetchData('fullTimeStatus', filter)}
                />
              </FormItem>
            )}
            {type === 'campus' && (
              <FormItem
                formItemKey="labLevelName"
                className="form_item_laboratory_select"
                span="3"
                labelWidth={0}
                required
                message="请选择实验室等级"
              >
                <div className="label">
                  实验室<span className="icon">*</span>
                </div>
                <Select
                  toFormItem
                  size="large"
                  placeholder="请选择"
                  labelField="name"
                  keyField="id"
                  notFoundMessage={filterStatus?.[`laboratoryLevel-${index}`] ? '无数据' : '请输入'}
                  // @ts-ignore
                  onFetchData={(filter) => handleFetchData('laboratoryLevel', filter, index)}
                />
              </FormItem>
            )}
            {type === 'campus' && (
              <FormItem
                className="form_item_laboratory"
                formItemKey="laboratory"
                span="8"
                labelWidth={0}
                rules={labLevelNameSelect ? [{ required: true, message: '请输入实验室' }] : []}
              >
                <div className="label"> </div>
                <Input toFormItem size="large" placeholder="请输入实验室" disabled={!labLevelNameSelect} />
              </FormItem>
            )}
            {type === 'campus' && (
              <FormItem formItemKey="mentor" span="11" labelWidth={0} required message="请输入导师姓名">
                <div className="label">
                  导师<span className="icon">*</span>
                </div>
                <Input toFormItem size="large" placeholder="如无导师可填写无" maxLength={50} />
              </FormItem>
            )}
            {type === 'campus' && (
              <FormItem formItemKey="researchDirection" span="11" labelWidth={0}>
                <div className="label">研究方向</div>
                <Input toFormItem size="large" placeholder="请输入研究方向" />
              </FormItem>
            )}
          </Form>
          <div className="delete-list">
            <div onClick={() => deleteResumeEduExpList(index)}>删除这段经历</div>
          </div>
        </div>
      ))}

      <div
        className="list_add"
        onClick={() => {
          store.addResumeList('resumeEduExpList');
        }}
      >
        <div className="add_icon">
          <img src={require('@imgs/add.svg')} alt="" />
        </div>
        添加教育经历
      </div>
    </div>
  );
}

export default ModuleView(observer(EduExperience), 'eduExperience');
